import { useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { CreateCoupon, CreateCouponWithExistingConditions } from "components/shared/promotion/forms";

export const WPSCreatePromotion: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const renderForm = () => {
    switch (params?.type) {
      case "existing": return <CreateCouponWithExistingConditions />;
      case "new": return <CreateCoupon />;
      default: return <></>;
    }
  }
  return (
    <div className="wrapper p-4">
      <Breadcrumbs customPageLabel={params?.type === "existing" ? "Existing Promotion" : "Create Promotion"} />
      {renderForm()}
    </div>
  );
};
